var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/flashOff.01edb8ef.png","uri@2x": __webpack_public_path__ + "static/media/flashOff.e76d2290.png","uri@3x": __webpack_public_path__ + "static/media/flashOff.98c4f52f.png",
    width: 26,
    height: 30
});